import React from 'react';

const shimmer = 'animate-pulse bg-[#2A2A2A]/60 rounded';

export function FeedSkeleton({ count = 3 }) {
  return (
    <div className="space-y-6" data-testid="feed-skeleton">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="bg-[#141414] rounded-2xl overflow-hidden shadow-sm border border-[#1C1C1C]">
          <div className={`${shimmer} aspect-[4/3] rounded-none`} />
          <div className="p-4 space-y-2.5">
            <div className={`${shimmer} h-4 w-3/4`} />
            <div className={`${shimmer} h-3 w-1/2`} />
            <div className="flex gap-2 pt-1">
              <div className={`${shimmer} h-8 w-8 rounded-full`} />
              <div className={`${shimmer} h-8 w-8 rounded-full`} />
              <div className={`${shimmer} h-8 w-8 rounded-full`} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export function MemoryGridSkeleton({ count = 12 }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3" data-testid="memory-grid-skeleton">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="rounded-xl overflow-hidden">
          <div className={`${shimmer} aspect-square rounded-xl`} />
          <div className="pt-2 space-y-1.5">
            <div className={`${shimmer} h-3 w-3/4`} />
            <div className={`${shimmer} h-2.5 w-1/2`} />
          </div>
        </div>
      ))}
    </div>
  );
}

export function TimelineSkeleton() {
  return (
    <div className="space-y-8" data-testid="timeline-skeleton">
      {[1, 2].map(y => (
        <div key={y} className="space-y-4">
          <div className={`${shimmer} h-8 w-24`} />
          <div className="space-y-3">
            {[1, 2, 3].map(m => (
              <div key={m} className={`${shimmer} h-48 w-full rounded-2xl`} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export function DetailSkeleton() {
  return (
    <div className="max-w-5xl mx-auto" data-testid="detail-skeleton">
      <div className="grid lg:grid-cols-5 gap-8 pt-6">
        <div className="lg:col-span-3">
          <div className={`${shimmer} aspect-[4/3] rounded-2xl`} />
        </div>
        <div className="lg:col-span-2 space-y-4">
          <div className={`${shimmer} h-7 w-3/4`} />
          <div className={`${shimmer} h-4 w-1/2`} />
          <div className={`${shimmer} h-20 w-full rounded-xl`} />
          <div className="flex gap-2">
            <div className={`${shimmer} h-6 w-16 rounded-full`} />
            <div className={`${shimmer} h-6 w-16 rounded-full`} />
            <div className={`${shimmer} h-6 w-16 rounded-full`} />
          </div>
        </div>
      </div>
    </div>
  );
}

export function StatsSkeleton() {
  return (
    <div className="flex gap-3 overflow-x-auto pb-2">
      {[1, 2, 3, 4].map(i => (
        <div key={i} className={`${shimmer} h-16 w-28 rounded-xl flex-shrink-0`} />
      ))}
    </div>
  );
}
